import { cn } from '@/core/ui/cn';

export const Description = ({
  comment,
  replyCount,
  description,
  type,
}: {
  comment: string;
  replyCount: number;
  description?: string;
  type: 'hide' | 'delete' | 'resolve' | 'unhide' | 'resetLikes' | 'resetDislikes' | 'review' | 'unreview';
}) => {
  const mapping = {
    hide: 'hide',
    delete: 'delete',
    resolve: 'resolve',
    unhide: 'unhide',
    resetLikes: 'reset likes',
    resetDislikes: 'reset dislikes',
    review: 'review question',
    unreview: 'unreview question',
  };
  return (
    <div className='flex flex-col'>
      <p className='text-default-700'>
        {description || `Are you sure you want to ${mapping[type]} this comment?`}
      </p>

      {replyCount > 0 && type !== 'resetLikes' && type !== 'resetDislikes' && (
        <p className={cn('text-warning-600 font-medium', { 'text-danger-600': type === 'delete' })}>
          This will also {mapping[type]} {replyCount} {replyCount === 1 ? 'reply' : 'replies'} to this
          comment.
        </p>
      )}

      <br />

      <div className='text-sm break-words border bg-default-100 border-default-300 rounded-lg p-3 font-mono'>
        <code className='text-default-800'>{comment}</code>
      </div>
    </div>
  );
};
